import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import EditIcon from "../../../assets/icon/Edit.svg";

import CloseIcon from "@mui/icons-material/Close";
import { userProfileUpdate } from "../../../services/MainApiDetails";
import { ERROR } from "../../../utilities/colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddPhoneModal = (prop) => {
  const [open, setOpen] = React.useState(false);
  const [userAddPhone, setUserAddPhone] = React.useState("");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    setUserAddPhone(prop.phone || "");
    if(open) setError("")
  }, [prop.phone, open]);

  const buttonDisabled = React.useMemo(
    () => (prop.phone?.trim() ?? "") === userAddPhone?.trim(),
    [prop.phone, userAddPhone],
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  function validatePhone() {
    var validation = false;

    let regex = /^(\+?[0-9]{2})?([0-9]{10})$/;
    validation = regex.test(userAddPhone);

    return validation;
  }
  function updateChangePhone() {
    if (!userAddPhone || !validatePhone()) {
      setError("Please Enter valid phone number");
    } else {
      userProfileUpdate({
        alt_phone: userAddPhone?.trim(),
      })
        .then((res) => {
          if (res.data.status) {
            alert("Phone number updated successfully");
            setOpen(false);
            window.location.reload();
          } else {
            alert(res.data.message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  return (
    <div className="editNameModal">
      <div onClick={handleClickOpen} className="userInfo-edit">
        <img src={EditIcon} alt="" />
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="editNameModal-wrapper">
          <div className="editNameModal-closeIcon">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
          <div className="editNameModal-header">
            <h2>{prop?.phone ? "Edit":"Add"} Alternate Phone Number</h2>
          </div>
          <div className="editNameModal-form-wrapper">
            <form action="">
              <div className="editNameModal-input-wrapper">
                <div className="editNameModal-inputBox">
                  <span>Enter new number</span>
                  <input
                    value={userAddPhone}
                    type="text"
                    placeholder="Type here"
                    onChange={(e) => setUserAddPhone(e.target.value)}
                  />
                  <span style={{ color: ERROR }}>{error}</span>
                </div>
              </div>
            </form>
          </div>
          <div className="editNameModal-button-wrapper">
            <Button
              type="button"
              disabled={buttonDisabled}
              onClick={() => updateChangePhone()}
              className={
                buttonDisabled
                  ? "editNameModal-login-btn-disabled"
                  : "editNameModal-login-btn"
              }
            >
              {!!prop.phone ? "UPDATE" : "CONFIRM"}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AddPhoneModal;
